import Orb360Embed from './Orb360Embed'

export default Orb360Embed
